import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SupportAttachment } from '../../common/general-types/support-ticket';
import { isImageAttachment } from '../../common/support-attachment.util';

@Component({
  selector: 'app-support-attachments-display',
  templateUrl: './support-attachments-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupportAttachmentsDisplayComponent {
  readonly attachments = input<SupportAttachment[]>([]);

  isImage(fileType: string): boolean {
    return isImageAttachment(fileType);
  }
}
